import { InputBase } from './input-base.class';

export class RadioInput extends InputBase<string> {
  controlType = 'radio';
  options: { key: string; value: string; translate?: boolean }[] = [];

  constructor(options = {}) {
    super(options);
    this.options = options['options'] || [];
  }
}
